export default "__VITE_ASSET__BSIbK2wO__"